export const user_login = "user/login";
export const user_init = "user/init";
export const refresh_token = "auth/token/refresh";
export const password_recovery = "q8/user/password-forgotten";
export const user_register = "q8/user/register";
export const user_credentials_update = "user/password/update";
export const get_hierarchy_info = "q8/hierarchy/user";
export const payer_code_verify_registrazione ="q8/user/verifica_codice_gestore_registrazione/*";
export const payer_code_verify = "q8/user/verifica_codice_gestore/*";
export const container = "learning-paths/user";
export const container_by_pv = "learning-paths/pv/*";
export const districts_list = "q8/hierarchy/dm";
export const rcr_area = "q8/hierarchy/*/children";
export const get_pv_list = "q8/hierarchy/rcr/*/punti-vendita-info";
export const get_pv_list_from_hierarchy = "q8/hierarchy/punti-vendita-info";
export const update_pv_list = "q8/user/assign_pv";
export const get_document_list = "attachment-pv/search";
export const get_document_categories = "attachment-category/list";
export const get_message_list = "app_message/fetch";
export const set_message_read = "app_message/read";
export const upload_document = "attachment/presigned-upload-url";
export const download_document = "attachment/presigned-download-url/*";
export const delete_document = "attachment/*";
export const get_check_list = "checklist-answers/pv/*";
export const get_checklist_form = "checklists/current-version";
export const check_list_confirm = "checklist-answers/*/confirm";
export const check_list_delete = "checklist-answers/*";
export const create_draft = "checklist-answers/pv/*";
export const get_secondary_users_list = "q8/user/sub-accounts/list";
export const change_status_secondary_user = "q8/user/sub-accounts/*";
export const user_progress = "user/core_completion";
export const user_mfa_active = "user/mfa";
export const user_send_code = "user/mfa/create_send";
export const user_check_code = "user/mfa/check";
export const authorization_code = "user/authorization_code";
export const heartbeat = "user/heartbeat";
export const get_user_pv = "q8/user/search";
export const change_password = "user/password/update";
export const change_notification_status = "user/email_notifications";
export const checklist_notification = "checklist-answers/*/share";
export const pv_stats_export = "q8/stats/export/gestori/pv";
export const add_punto_vendita = "q8/user/add-punto-endita/*";
export const pv_codice_gestore = "q8/user/pv_codice_gestore/*";

